<div class="mx-auto px-4 py-6 overflow-x-auto">
  <!-- Error state -->
  @if (hasError()) {
  <shared-error-message
    message="Error al cargar las categorías"
  ></shared-error-message>
  } @else if (isLoading()) {
  <!-- Skeleton loaders para móvil -->
  <div class="block md:hidden">
    <div class="space-y-4">
      <ngx-skeleton-loader
        [theme]="{
          height: '180px',
          width: '100%',
          'background-color': '#E5E7EB',
          'border-radius': '12px'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>

  <!-- Skeleton loaders para desktop -->
  <div class="hidden md:block">
    <div class="flex space-x-4">
      @for (i of [1, 2, 3,4,5,6]; track i) {
      <ngx-skeleton-loader
        [theme]="{
          height: '250px',
          width: '400px',
          'background-color': '#E5E7EB',
          'border-radius': '12px'
        }"
      ></ngx-skeleton-loader>
      }
    </div>
  </div>
  } @else {
  <div>
    <!-- Versión móvil (slider) -->
    <div class="block md:hidden">
      <div class="relative">
        <!-- Indicadores de navegación -->
        <div class="flex justify-center mt-2 mb-4">
          @for(categorieGRal of categoriesGral(); track $index) {
          <div
            class="h-1.5 w-6 mx-1 rounded-full transition-all duration-300"
            [class.bg-orange-500]="currentSlide() === $index"
            [class.bg-gray-300]="currentSlide() !== $index"
          ></div>
          }
        </div>

        <!-- Slider -->
        <div class="overflow-hidden">
          <div
            class="flex transition-transform duration-300 ease-in-out"
            [style.transform]="'translateX(-' + currentSlide() * 100 + '%)'"
          >
            @for(categorieGRal of categoriesGral(); track $index) {
            <div
              [class]="
                typeEatBarService.colors[
                  $index % typeEatBarService.colors.length
                ]
              "
              class="flex-none w-full rounded-xl overflow-hidden relative text-white h-[180px]"
            >
              <div
                class="absolute inset-0 flex flex-col justify-end p-4 z-10 bg-gradient-to-t from-black/60 to-transparent"
              >
                <h2 class="text-lg font-bold mb-1 line-clamp-1">
                  {{ categorieGRal.name }}
                </h2>
                <button
                  (click)="navigateEstablishmentForCategorie(categorieGRal.id)"
                  class="bg-white text-orange-500 font-bold py-1.5 px-4 rounded-full text-sm hover:bg-yellow-100 transition-colors"
                >
                  Pide ya
                </button>
              </div>
              <img
                [src]="categorieGRal.icono"
                [alt]="categorieGRal.name"
                class="w-full h-full object-cover absolute inset-0"
              />
            </div>
            }
          </div>
        </div>

        <!-- Botones de navegación -->
        <button
          (click)="prevSlide()"
          class="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 p-1.5 rounded-full shadow-md z-20 -ml-1"
          [class.hidden]="currentSlide() === 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          (click)="nextSlide()"
          class="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 p-1.5 rounded-full shadow-md z-20 -mr-1"
          [class.hidden]="currentSlide() >= categoriesGral().length - 1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Versión desktop (original) -->
    <div class="hidden md:block">
      <div class="flex space-x-4 w-full">
        @for(categorieGRal of categoriesGral(); track $index){
        <div
          [class]="
            typeEatBarService.colors[$index % typeEatBarService.colors.length]
          "
          class="cursor-pointer flex-none w-[350px] h-[150px] rounded-xl overflow-hidden relative text-white"
          (mouseenter)="onCardEnter($index)"
          (mouseleave)="onCardLeave($index)"
          #cardItem
        >
          <div class="flex flex-col md:flex-row items-center h-full">
            <div class="p-6 md:w-2/3 z-10">
              <h2 class="text-2xl font-bold mb-2">
                {{ categorieGRal.name }}
              </h2>
              <button
                (click)="navigateEstablishmentForCategorie(categorieGRal.id)"
                class="cursor-pointer bg-white text-orange-500 font-bold py-2 px-6 rounded-full mt-2 hover:bg-yellow-100 transition-colors"
              >
                Pide ya
              </button>
            </div>
            <div class="md:w-2/3 relative flex justify-end h-full">
              <div class="flex items-end justify-end h-full">
                <img
                  [src]="categorieGRal.icono"
                  [alt]="categorieGRal.name"
                  class="w-full h-full object-cover"
                  #catImage
                />
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
